import { markdown } from 'markdown';
import DOMPurify from 'dompurify';

class Parser {
    toHTML(data) {
        var html = markdown.toHTML(data);
        var sanitizedHtml = DOMPurify.sanitize(html);

        var finder = new RegExp('%yt [a-zA-Z0-9_]*%');
        var results = finder.exec(sanitizedHtml);

        while (results !== null && results !== undefined) {
            for (var i = 0; i < results.length; i++) {
                var result = results[i];
                
                var id = result.substring(4, result.length - 1);
                
                var embed = 
                    `
                        <div class="embed">
                            <iframe class="embed-frame"
                                src="https://www.youtube.com/embed/${id}" 
                                frameborder="0" allow="accelerometer; autoplay; 
                                encrypted-media; gyroscope; picture-in-picture" 
                                allowfullscreen>
                            </iframe>
                        </div>
                    `;

                sanitizedHtml = sanitizedHtml.replace(result, embed);
            }

            results = finder.exec(sanitizedHtml);
        }

        return sanitizedHtml;
    }
};

export default Parser;


// WEBPACK FOOTER //
// ./src/Post/MarkdownParser.js